export default __webpack_public_path__ + "static/media/content-deco-3.79c642fd.webp";